import { normaliseHexColour } from '../styles/colour';

/** Transient logical-pixel presentation. Zero remains zero; small authored sizes never grow. */
export function presentationScale(value = 1): number {
  return Number.isFinite(value) && value > 0 ? Math.min(1, value) : 1;
}

export function presentationDimension(value: number, scale: number, minimum = 0): number {
  return Math.min(value, Math.max(Math.min(value, minimum), value * presentationScale(scale)));
}

export const DEFAULT_MAP_BACKGROUND_COLOUR = '#dfe7e6';

export function normaliseMapBackgroundColour(value: unknown): string | null {
  return typeof value === 'string' ? normaliseHexColour(value) : null;
}
